function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Edit(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.814 1.878l1.123 1.123.016.015 1.107 1.108c.566.566.878 1.32.878 2.121 0 .802-.312 1.554-.878 2.121L8.497 21.93a1.005 1.005 0 01-.585.286l-5.79.714a1 1 0 01-1.115-1.114l.715-5.789a.994.994 0 01.286-.585L15.57 1.878a3.002 3.002 0 014.243 0zM13.62 6.656l-9.955 9.956-.515 4.176 4.176-.516 9.954-9.956-3.66-3.66zm3.365-3.364l-1.95 1.95 3.66 3.66 1.95-1.95a.992.992 0 00.293-.707.991.991 0 00-.293-.707L19.539 4.43l-.008-.007-1.131-1.13a1 1 0 00-1.415 0z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoEdit = /*#__PURE__*/React.memo(Edit);
export default MemoEdit;